<template>
  <div>
    <div class="row" v-if="loading">
      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        align="center"
        style="min-height: calc(var(--vh, 1vh) * 80); display: flex"
      >
        <div style="margin: auto; text-align: center">
          <i style="font-size: 50px" class="fas fa-spinner fa-pulse"></i>

          <p style="font-size: 16px; font-weight: bold">Comprobando usuario</p>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card" style="border-radius: 0px">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li
              v-if="isAdmin || isSaludsa"
              class="nav-item"
              role="presentation"
            >
              <button
                @click="summaryLoad"
                class="nav-link"
                :class="activoPanel === 0 ? 'active' : ''"
                id="pills-summary-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-summary"
                type="button"
                role="tab"
                aria-controls="pills-summary"
                aria-selected="true"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-gauge text-success"
                ></i>
                Resumen
              </button>
            </li>

            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="leadsLoad"
                class="nav-link"
                :class="activoPanel === 1 ? 'active' : ''"
                id="pills-leads-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-leads"
                type="button"
                role="tab"
                aria-controls="pills-leads"
                aria-selected="true"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-filter-circle-dollar text-success"
                ></i>
                Leads
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="salesLoad"
                class="nav-link"
                :class="activoPanel === 2 ? 'active' : ''"
                id="pills-closed-deal-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-closed-deal"
                type="button"
                role="tab"
                aria-controls="pills-closed-deal"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-handshake text-success"
                ></i>
                Ventas
              </button>
            </li>
            <li
              v-if="isAdmin || isSaludsa"
              class="nav-item"
              role="presentation"
            >
              <button
                @click="closedPendingLoad"
                class="nav-link"
                :class="activoPanel === 18 ? 'active' : ''"
                id="pills-closed-pending-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-closed-pending"
                type="button"
                role="tab"
                aria-controls="pills-closed-pending"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-triangle-exclamation text-warning"
                ></i>
                Cerrados pendientes
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="withdrawalsLoad"
                class="nav-link"
                :class="activoPanel === 3 ? 'active' : ''"
                id="pills-withdrawals-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-withdrawals"
                type="button"
                role="tab"
                aria-controls="pills-withdrawals"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-money-bill-transfer text-success"
                ></i>
                Retiros
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="withdrawalsPaidLoad"
                class="nav-link"
                :class="activoPanel === 13 ? 'active' : ''"
                id="pills-withdrawals-paid-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-withdrawals-paid"
                type="button"
                role="tab"
                aria-controls="pills-withdrawals-paid"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-circle-check text-success"
                ></i>
                Retiros pagados
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="blockedContactsLoad"
                class="nav-link"
                :class="activoPanel === 4 ? 'active' : ''"
                id="pills-withdrawals-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-withdrawals"
                type="button"
                role="tab"
                aria-controls="pills-withdrawals"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-money-bill-transfer text-success"
                ></i>
                Usuarios bloqueados
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="providersLoad"
                class="nav-link"
                :class="activoPanel === 5 ? 'active' : ''"
                id="pills-withdrawals-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-withdrawals"
                type="button"
                role="tab"
                aria-controls="pills-withdrawals"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-hospital-user text-success"
                ></i>
                Listado prestadores
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="ejecutivoLoad"
                class="nav-link"
                :class="activoPanel === 6 ? 'active' : ''"
                id="pills-ejecutivo-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-ejecutivo"
                type="button"
                role="tab"
                aria-controls="pills-ejecutivo"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-user-tie text-success"
                ></i>
                Listado ejecutivos
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="patrocinadorLoad"
                class="nav-link"
                :class="activoPanel === 7 ? 'active' : ''"
                id="pills-patrocinador-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-patrocinador"
                type="button"
                role="tab"
                aria-controls="pills-patrocinador"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-handshake-angle text-success"
                ></i>
                Listado patrocinador
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="qrGeneratorLoad"
                class="nav-link"
                :class="activoPanel === 8 ? 'active' : ''"
                id="pills-withdrawals-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-withdrawals"
                type="button"
                role="tab"
                aria-controls="pills-withdrawals"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-qrcode text-success"
                ></i>
                Generar QR
              </button>
            </li>
            <li v-if="isSaludsa" class="nav-item" role="presentation">
              <button
                @click="ruletaLoad"
                class="nav-link"
                :class="activoPanel === 9 ? 'active' : ''"
                id="pills-ruleta-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-ruleta"
                type="button"
                role="tab"
                aria-controls="pills-ruleta"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-trophy text-success"
                ></i>
                Ruleta
              </button>
            </li>
            <li v-if="isSaludsa || isAdmin" class="nav-item" role="presentation">
              <button
                @click="reportesLoad"
                class="nav-link"
                :class="activoPanel === 10 ? 'active' : ''"
                id="pills-reportes-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-reportes"
                type="button"
                role="tab"
                aria-controls="pills-reportes"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-chart-bar text-success"
                ></i>
                Reportes
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="pruebasLoad"
                class="nav-link"
                :class="activoPanel === 11 ? 'active' : ''"
                id="pills-pruebas-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-pruebas"
                type="button"
                role="tab"
                aria-controls="pills-pruebas"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-vial text-success"
                ></i>
                Pruebas
              </button>
            </li>
            <li v-if="isAdmin || isSaludsa" class="nav-item" role="presentation">
              <button
                @click="contratosLoad"
                class="nav-link"
                :class="activoPanel === 12 ? 'active' : ''"
                id="pills-contratos-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-contratos"
                type="button"
                role="tab"
                aria-controls="pills-contratos"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-file-contract text-success"
                ></i>
                Contratos
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="jelouLoad"
                class="nav-link d-inline-flex align-items-center"
                :class="activoPanel === 14 ? 'active' : ''"
                id="pills-jelou-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-jelou"
                type="button"
                role="tab"
                aria-controls="pills-jelou"
                aria-selected="false"
              >
                <img
                  src="@/assets/img/Saludsa/jelou.svg"
                  alt=""
                  width="16"
                  height="16"
                  style="margin-right: 6px; border-radius: 4px; object-fit: contain"
                />
                Jelou
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="metaLoad"
                class="nav-link d-inline-flex align-items-center"
                :class="activoPanel === 17 ? 'active' : ''"
                id="pills-meta-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-meta"
                type="button"
                role="tab"
                aria-controls="pills-meta"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fab fa-whatsapp text-success"
                ></i>
                Meta
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="mailingLoad"
                class="nav-link"
                :class="activoPanel === 15 ? 'active' : ''"
                id="pills-mailing-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-mailing"
                type="button"
                role="tab"
                aria-controls="pills-mailing"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-envelope text-success"
                ></i>
                Mailing
              </button>
            </li>
            <li v-if="isAdmin" class="nav-item" role="presentation">
              <button
                @click="testingLoad"
                class="nav-link"
                :class="activoPanel === 16 ? 'active' : ''"
                id="pills-testing-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-testing"
                type="button"
                role="tab"
                aria-controls="pills-testing"
                aria-selected="false"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-flask text-success"
                ></i>
                Testing
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        style="margin-top: 15px"
      >
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade"
            :class="activoPanel === 0 ? 'show active' : ''"
            id="pills-summary"
            role="tabpanel"
            aria-labelledby="pills-summary-tab"
            tabindex="0"
          >
            <div>
              <Resumen :token-auth="tokenAuth" />
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 1 ? 'show active' : ''"
            id="pills-leads"
            role="tabpanel"
            aria-labelledby="pills-leads-tab"
            tabindex="0"
          >
            <listado-leads
              v-if="ifLeads"
              :key="componentKeyLeadsList"
              :user-id="userId"
              :token-auth="tokenAuth"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 2 ? 'show active' : ''"
            id="pills-closed-deal"
            role="tabpanel"
            aria-labelledby="pills-closed-deal-tab"
            tabindex="0"
          >
            <listado-conversiones
              v-if="ifSales"
              :key="componentKeyConversionsList"
              :user-id="userId"
              :token-auth="tokenAuth"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 18 ? 'show active' : ''"
            id="pills-closed-pending"
            role="tabpanel"
            aria-labelledby="pills-closed-pending-tab"
            tabindex="0"
          >
            <listado-cerrados-pendientes
              v-if="ifClosedPending"
              :key="componentKeyClosedPendingList"
              :token-auth="tokenAuth"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 3 ? 'show active' : ''"
            id="pills-withdrawals"
            role="tabpanel"
            aria-labelledby="pills-withdrawals-tab"
            tabindex="0"
          >
            <listado-retiros
              v-if="ifWithdrawals"
              :key="componentKeyRetiros"
              :user-id="userId"
              :token-auth="tokenAuth"
              :id-admin="idAdmin"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 13 ? 'show active' : ''"
            id="pills-withdrawals-paid"
            role="tabpanel"
            aria-labelledby="pills-withdrawals-paid-tab"
            tabindex="0"
          >
            <listado-retiros-pagados
              v-if="ifWithdrawalsPaid"
              :key="componentKeyRetirosPaid"
              :token-auth="tokenAuth"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 4 ? 'show active' : ''"
            id="pills-withdrawals"
            role="tabpanel"
            aria-labelledby="pills-withdrawals-tab"
            tabindex="0"
          >
            <blocked-users-list :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 5 ? 'show active' : ''"
            id="pills-withdrawals"
            role="tabpanel"
            aria-labelledby="pills-withdrawals-tab"
            tabindex="0"
          >
            <providers-admin :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 6 ? 'show active' : ''"
            id="pills-ejecutivo"
            role="tabpanel"
            aria-labelledby="pills-ejecutivo-tab"
            tabindex="0"
          >
            <listado-ejecutivo v-if="ifEjecutivo" :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 7 ? 'show active' : ''"
            id="pills-patrocinador"
            role="tabpanel"
            aria-labelledby="pills-patrocinador-tab"
            tabindex="0"
          >
            <listado-patrocinador
              v-if="ifPatrocinador"
              :token-auth="tokenAuth"
            />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 8 ? 'show active' : ''"
            id="pills-withdrawals"
            role="tabpanel"
            aria-labelledby="pills-withdrawals-tab"
            tabindex="0"
          >
            <qr-generator />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 9 ? 'show active' : ''"
            id="pills-ruleta"
            role="tabpanel"
            aria-labelledby="pills-ruleta-tab"
            tabindex="0"
          >
            <ruleta-admin v-if="ifRuleta" :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 10 ? 'show active' : ''"
            id="pills-reportes"
            role="tabpanel"
            aria-labelledby="pills-reportes-tab"
            tabindex="0"
          >
            <reportes v-if="ifReportes" :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 11 ? 'show active' : ''"
            id="pills-pruebas"
            role="tabpanel"
            aria-labelledby="pills-pruebas-tab"
            tabindex="0"
          >
            <pruebas-correo v-if="ifPruebas" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 12 ? 'show active' : ''"
            id="pills-contratos"
            role="tabpanel"
            aria-labelledby="pills-contratos-tab"
            tabindex="0"
          >
            <contratos v-if="ifContratos" :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 14 ? 'show active' : ''"
            id="pills-jelou"
            role="tabpanel"
            aria-labelledby="pills-jelou-tab"
            tabindex="0"
          >
            <jelou-admin v-if="ifJelou" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 17 ? 'show active' : ''"
            id="pills-meta"
            role="tabpanel"
            aria-labelledby="pills-meta-tab"
            tabindex="0"
          >
            <meta-admin v-if="ifMeta" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 15 ? 'show active' : ''"
            id="pills-mailing"
            role="tabpanel"
            aria-labelledby="pills-mailing-tab"
            tabindex="0"
          >
            <mailing-admin v-if="ifMailing" :token-auth="tokenAuth" />
          </div>
          <div
            class="tab-pane fade"
            :class="activoPanel === 16 ? 'show active' : ''"
            id="pills-testing"
            role="tabpanel"
            aria-labelledby="pills-testing-tab"
            tabindex="0"
          >
            <import-region-ryg v-if="ifTesting" :token-auth="tokenAuth" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import "bootstrap"; //no eliminar, este le da el evento al nav pills
import ListadoLeads from "./ListadoLeads.vue";
import ListadoConversiones from "./ListadoConversiones.vue";
import ListadoCerradosPendientes from "./ListadoCerradosPendientes.vue";
import ListadoRetiros from "./ListadoRetiros.vue";
import ListadoRetirosPagados from "./ListadoRetirosPagados.vue";
import ProvidersAdmin from "./ProvidersAdmin.vue";
import BlockedUsersList from "./BlockedUsersList.vue";
import Resumen from "./Resumen.vue";
import QrGenerator from "./QrGenerator.vue";
import ListadoEjecutivo from "./ListadoEjecutivo.vue";
import ListadoPatrocinador from "./ListadoPatrocinador.vue";
import RuletaAdmin from "./RuletaAdmin.vue";
import Reportes from "./Reportes.vue";
import PruebasCorreo from "./PruebasCorreo.vue";
import Contratos from "./Contratos.vue";
import JelouAdmin from "./JelouAdmin.vue";
import MetaAdmin from "./MetaAdmin.vue";
import MailingAdmin from "./Mailing.vue";
import ImportRegionRyg from "./ImportRegionRyg.vue";
import { JSEncrypt } from "jsencrypt";
import keys from "@/store/keys";

export default {
  components: {
    ListadoLeads,
    ListadoRetiros,
    ListadoRetirosPagados,
    ListadoConversiones,
    ListadoCerradosPendientes,
    Resumen,
    BlockedUsersList,
    ProvidersAdmin,
    QrGenerator,
    ListadoEjecutivo,
    ListadoPatrocinador,
    RuletaAdmin,
    Reportes,
    PruebasCorreo,
    Contratos,
    JelouAdmin,
    MetaAdmin,
    MailingAdmin,
    ImportRegionRyg,
  },
  data() {
    const datos = JSON.parse(localStorage.getItem("userData"));

    return {
      isMobile: this.$isMobile,
      userId: datos.userId,
      tokenAuth: datos.tokenAuth,
      role: null,
      idAdmin: "",
      loading: true,
      componentKey: 0,
      activoPanel: 0,
      componentKeyLeadsList: 100,
      componentKeyConversionsList: 200,
      componentKeyClosedPendingList: 210,
      ifLeads: false,
      ifWithdrawals: false,
      ifWithdrawalsPaid: false,
      ifSales: false,
      ifClosedPending: false,
      ifSummary: false,
      ifQrGenerator: false,
      ifBlockedContacts: false,
      ifProviders: false,
      ifEjecutivo: false,
      ifPatrocinador: false,
      ifRuleta: false,
      ifReportes: false,
      ifPruebas: false,
      ifContratos: false,
      ifJelou: false,
      ifMeta: false,
      ifMailing: false,
      ifTesting: false,
      componentKeyRetiros: 300,
      componentKeyRetirosPaid: 310,
      isAdmin: false,
      isSaludsa: false,
    };
  },
  watch: {
    $route(to, from) {
      var hash = to.hash.substring(1); //Puts hash in variable, and removes the # character
      switch (hash) {
        case "resumen":
          this.activoPanel = 0;
          this.ifSummary = true;
          break;
        case "leads":
          this.activoPanel = 1;
          this.ifLeads = true;
          break;
        case "closed-deal":
          this.activoPanel = 2;
          this.ifSales = true;
          break;
        case "closed-pending":
          this.activoPanel = 18;
          this.ifClosedPending = true;
          break;
        case "withdrawals":
          this.activoPanel = 3;
          this.ifWithdrawals = true;
          break;
        case "withdrawals-paid":
          this.activoPanel = 13;
          this.ifWithdrawalsPaid = true;
          break;
        case "blocked-contacts":
          this.activoPanel = 4;
          this.ifBlockedContacts = true;
          break;
        case "providers":
          this.activoPanel = 5;
          this.ifProviders = true;
          break;
        case "pruebas":
          this.activoPanel = 11;
          this.ifPruebas = true;
          break;
        case "contratos":
          this.activoPanel = 12;
          this.ifContratos = true;
          break;
        case "jelou":
          this.activoPanel = 14;
          this.ifJelou = true;
          break;
        case "meta":
          this.activoPanel = 17;
          this.ifMeta = true;
          break;
        case "mailing":
          this.activoPanel = 15;
          this.ifMailing = true;
          break;
        case "testing":
          this.activoPanel = 16;
          this.ifTesting = true;
          break;
        case "import-contrato":
          this.activoPanel = 12;
          this.ifContratos = true;
          break;
        default:
          this.activoPanel = 0;
          this.ifSummary = true;
          this.ifJelou = false;
          this.ifMeta = false;
          this.ifMailing = false;
          this.ifTesting = false;
      }
    },
  },
  created() {},
  activated() {
    this.decryptedRole();
    if (this.isMobile) {
      this.$eventBus.emit("inactiveShowMenu");
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.decryptedRole(); // recheck role
    this.init(); // reinitialize the component as needed
    next();
  },
  mounted() {
    this.$eventBus.on("reiniciarListadoVentasAdmin", () => {
      this.componentKeyLeadsList += 1;
    });

    this.$eventBus.on("reiniciarAdmin", () => {
      this.componentKey += 1;
    });

    document.title = "Saludsa Refiere y Gana - Administración";
    this.decryptedRole();
    this.init();
  },
  computed: {},
  methods: {
    init() {
      this.decryptedRole();
      if (!this.isUser) {
        if (this.isAdmin) {
          this.ifSummary = true;
          this.activoPanel = 0;
        } else if (this.isSaludsa) {
          this.ifSummary = true;
          this.activoPanel = 0;
        }
        this.loading = false;
      } else {
        this.loading = true;
      }
    },
    decryptedRole() {
      const session = localStorage.getItem("session");
      const decrypt = new JSEncrypt();
      decrypt.setPrivateKey(keys.privateKeyBackoffice);
      const role = decrypt.decrypt(session);
      this.isAdmin = role === "admin";
      this.isSaludsa = role === "saludsa";
      this.isUser = role === "user";
    },
    summaryLoad() {
      this.ifSummary = true;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 0;
    },
    leadsLoad() {
      this.ifLeads = true;
      this.ifClosedPending = false;
      this.ifSales = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSummary = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 1;
    },
    salesLoad() {
      this.ifSales = true;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSummary = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 2;
    },
    closedPendingLoad() {
      this.ifClosedPending = true;
      this.ifSales = false;
      this.ifLeads = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSummary = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 18;
    },
    withdrawalsLoad() {
      this.ifWithdrawals = true;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 3;
    },
    withdrawalsPaidLoad() {
      this.ifWithdrawalsPaid = true;
      this.ifWithdrawals = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifBlockedContacts = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 13;
    },
    blockedContactsLoad() {
      this.ifBlockedContacts = true;
      this.ifWithdrawalsPaid = false;
      this.ifWithdrawals = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifProviders = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 4;
    },
    providersLoad() {
      this.ifProviders = true;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifQrGenerator = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 5;
    },
    ejecutivoLoad() {
      this.ifEjecutivo = true;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifQrGenerator = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 6;
    },
    patrocinadorLoad() {
      this.ifPatrocinador = true;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifQrGenerator = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 7;
    },
    qrGeneratorLoad() {
      this.ifQrGenerator = true;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifRuleta = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 8;
    },
    ruletaLoad() {
      this.ifRuleta = true;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifReportes = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 9;
    },
    reportesLoad() {
      this.ifReportes = true;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifPruebas = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 10;
    },
    pruebasLoad() {
      this.ifPruebas = true;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifContratos = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 11;
    },
    contratosLoad() {
      this.ifContratos = true;
      this.ifPruebas = false;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifMailing = false;
      this.ifTesting = false;
      this.activoPanel = 12;
    },
    jelouLoad() {
      this.ifJelou = true;
      this.ifMeta = false;
      this.ifContratos = false;
      this.ifPruebas = false;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.activoPanel = 14;
      this.ifMailing = false;
      this.ifTesting = false;
    },
    metaLoad() {
      this.ifMeta = true;
      this.ifJelou = false;
      this.ifContratos = false;
      this.ifPruebas = false;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.activoPanel = 17;
      this.ifMailing = false;
      this.ifTesting = false;
    },
    mailingLoad() {
      this.ifMailing = true;
      this.ifTesting = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifContratos = false;
      this.ifPruebas = false;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.activoPanel = 15;
    },
    testingLoad() {
      this.ifTesting = true;
      this.ifMailing = false;
      this.ifJelou = false;
      this.ifMeta = false;
      this.ifContratos = false;
      this.ifPruebas = false;
      this.ifReportes = false;
      this.ifRuleta = false;
      this.ifQrGenerator = false;
      this.ifProviders = false;
      this.ifBlockedContacts = false;
      this.ifWithdrawals = false;
      this.ifWithdrawalsPaid = false;
      this.ifSales = false;
      this.ifClosedPending = false;
      this.ifLeads = false;
      this.ifSummary = false;
      this.ifEjecutivo = false;
      this.ifPatrocinador = false;
      this.activoPanel = 16;
    },
  },
};
</script>

<style lang="scss"></style>
